export default __webpack_public_path__ + "static/media/iyadunni.cc74ee11.jpg";